import { render } from "./UpgradeModal.vue?vue&type=template&id=274ce046&scoped=true"
import script from "./UpgradeModal.vue?vue&type=script&lang=js"
export * from "./UpgradeModal.vue?vue&type=script&lang=js"

import "./UpgradeModal.vue?vue&type=style&index=0&id=274ce046&scoped=true&lang=css"
import "./UpgradeModal.vue?vue&type=style&index=1&id=274ce046&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274ce046"]])

export default __exports__